// extracted by mini-css-extract-plugin
export default {"modalContainer":"modalContainer___CCCyf","footer":"footer___ugn40","btn":"btn___jqIcF"};